import axios from "axios";

// تابع برای ایجاد هدرهای شامل توکن
export const createAxiosHeaders = () => {
  const token = localStorage.getItem("access_token");
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
       
      },
    };
  }
  return {
    headers: {
      "Content-Type": "application/json",
    },
  };
};

// نمونه axios با آدرس پایه
const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const getCache = new Map();
const inflightGetRequests = new Map();

const buildCacheKey = (url, config = {}, cacheKey) => {
  if (cacheKey) return String(cacheKey);
  const params = config?.params ? JSON.stringify(config.params) : "";
  const auth = config?.headers?.Authorization || "";
  return `GET|${url}|${params}|${auth}`;
};

export const apiGetCached = (url, config = {}, options = {}) => {
  const { ttlMs = 30000, force = false, cacheKey } = options;
  const key = buildCacheKey(url, config, cacheKey);
  const now = Date.now();

  if (!force) {
    const cached = getCache.get(key);
    if (cached && cached.expiresAt > now) {
      return Promise.resolve(cached.response);
    }
  }

  if (!force && inflightGetRequests.has(key)) {
    return inflightGetRequests.get(key);
  }

  const request = API.get(url, config)
    .then((response) => {
      if (ttlMs > 0) {
        getCache.set(key, {
          response,
          expiresAt: Date.now() + ttlMs,
        });
      }
      return response;
    })
    .finally(() => {
      inflightGetRequests.delete(key);
    });

  inflightGetRequests.set(key, request);
  return request;
};

export const invalidateApiCache = (keyOrPredicate) => {
  if (!keyOrPredicate) return;
  if (typeof keyOrPredicate === "function") {
    for (const key of getCache.keys()) {
      if (keyOrPredicate(key)) {
        getCache.delete(key);
      }
    }
    return;
  }
  getCache.delete(String(keyOrPredicate));
};

export const clearApiCache = () => {
  getCache.clear();
  inflightGetRequests.clear();
};

export default API;
